import { Injectable } from '@angular/core';
//import { PageErrorModel } from '../../domain/models/internal/page-error.model';
import { statusError } from '../routes/status-error';
import { StatusErrorModel } from '../../domain/models/internal/status-error.model';
//import { StatusErrorModel } from '../../domain/models/internal/status-error.model';


@Injectable({
    providedIn:'root'
})
export class ErrorsService {
    // dataError:PageErrorModel ;
    // constructor(){
    //    this.dataError = {
    //     image:"",
    //     message:"",
    //     subtitle:"",
    //     title:"",
    //     routeBack:"",
    //     showExit:false,
    //     showBack:false,
    //     typeButton:0
    //    };
    // }

    // setDataError(data:PageErrorModel){
    //     this.dataError = data;
    // }

    // getDataError(){
    //     return this.dataError;
    // }

    searchStatus(code:number){
        let message;
        message = statusError.find((e:StatusErrorModel)=> e.code === code )?.message;
        return message;
    }

}